{
  "it": {
    "company": {
      "actions": {
        "changeCompany": "Cambia azienda",
        "searchCompany": "Cerca azienda"
      },
      "attributes": {
        "address": "Indirizzo",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Lingua",
        "name": "Nome azienda",
        "phone": "Telefono",
        "subdomain": "Sottodominio",
        "vat": "Partita IVA"
      },
      "labels": {
        "company": "Azienda",
        "contact": "Contatto",
        "contacts": "Contatti",
        "language": "Questa è la lingua predefinita dell'azienda per la Sua pagina di accesso, i clienti e i membri del team.",
        "or": "O"
      },
      "validation": {
        "contactAlreadyExist": "Il contatto esiste già. Selezioni dal menu a discesa.",
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "needName": "Il nome è obbligatorio"
      }
    }
  }
}
